import { HttpErrorResponse } from '@angular/common/http';

function messageFromBody(body: unknown, fallback: string): string {
  if (body == null) {
    return fallback;
  }

  if (typeof body === 'string') {
    const trimmed = body.trim();
    if (!trimmed) {
      return fallback;
    }

    try {
      return messageFromBody(JSON.parse(trimmed), fallback);
    } catch {
      return trimmed;
    }
  }

  if (typeof body !== 'object') {
    return fallback;
  }

  const message = (body as { message?: unknown }).message;

  if (typeof message === 'string' && message.trim()) {
    return message.trim();
  }

  if (Array.isArray(message)) {
    const first = message.find(
      (item): item is string =>
        typeof item === 'string' && item.trim().length > 0,
    );

    if (first) {
      return first.trim();
    }
  }

  return fallback;
}

export function httpErrorMessageFromBody(body: unknown, fallback: string): string {
  if (body instanceof Blob) {
    return fallback;
  }

  return messageFromBody(body, fallback);
}

export function httpErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpErrorResponse) {
    return httpErrorMessageFromBody(error.error, fallback);
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }

  return fallback;
}
